import React, { useEffect } from 'react';
import { getDataSession } from 'views/Utils/Common';
import { useLocation } from 'react-router';
import { useGlobalState } from 'resources/GlobalStateContext';
import { AuthTienda } from './AuthTienda';

const TiendaNube = ({ history }) => {
    const { globalTitulo, setGlobalTitulo } = useGlobalState();
    let { search } = useLocation();
    let query = new URLSearchParams(search);
    let code = query.get('code');
    const id = getDataSession('sucursalTiendaNube');
    //console.log(id)
    const actualizarTitulo = () => {
        setGlobalTitulo({
            ...globalTitulo,
            titulo: 'Empresa',
            subtitulo: ''
        });
    };

    useEffect(() => { actualizarTitulo(); });

    return (<AuthTienda history={history} tienda='TIENDANUBE' code={code} sucursal_id={id} isNoLogin={false}></AuthTienda>);
};

const TiendaNubeNoLogin = ({ history }) => {
    let { search } = useLocation();
    let query = new URLSearchParams(search);
    let code = query.get('code');

    return (<AuthTienda history={history} tienda='TIENDANUBE' code={code} isNoLogin={true}></AuthTienda>);
};

export { TiendaNube, TiendaNubeNoLogin };